import { FIND_STATEMENT_BY_PLAN } from '../../../queries';
import { Button, Loading, QuickEdit } from '../../../../../components';
import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { MissionForm } from '../../forms';
import BorderedSection from '../../../../../components/generic/BorderedSection';
import AntModal from '../../../../../components/generic/AntModal';
import QueryErrorBoundary from '../../../../../components/error-handling';
import {
  EMPTY_COMMENTARY_TEXT,
  EMPTY_SUMMARY_EXPRESSIONS,
} from '../../../strategies/StrategyComponents/constants';
import { useUserContext } from '../../../../../context/PermissionsContext';

export type FindStatementByPlan = {
  corporateObjectiveSummary: string;
  corporatePlanScopeSummary: string;
  uuid: string;
};

export interface MissionDataReturned {
  findStatementByPlan: FindStatementByPlan;
}

interface MissionObjectiveProps {
  planId: string;
  type: 'objective' | 'scope';
  title: string;
}

export function MissionSummary({
  planId,
  type,
  title,
}: Readonly<MissionObjectiveProps>) {
  const [open, setOpen] = useState(false);

  const { isAdmin, canEdit } = useUserContext();
  const { data, loading, error } = useQuery<MissionDataReturned>(
    FIND_STATEMENT_BY_PLAN,
    {
      variables: {
        uuid: planId,
      },
      skip: !planId,
    },
  );

  const summaryText =
    type === 'objective'
      ? data?.findStatementByPlan.corporateObjectiveSummary
      : data?.findStatementByPlan.corporatePlanScopeSummary;

  const includeEmptyExpressions =
    !summaryText ||
    EMPTY_SUMMARY_EXPRESSIONS.includes(summaryText?.split(' ')?.join(''));

  const summary = includeEmptyExpressions ? 'Add commentary...' : summaryText;

  const onCancel = () => {
    setOpen(false);
  };

  return (
    <>
      <BorderedSection title={title}>
        <QueryErrorBoundary error={error}>
          {!loading ? (
            <>
              <div className="flex h-full">
                {!loading ? (
                  <div
                    className={`tiptap w-full ${
                      summary === EMPTY_COMMENTARY_TEXT
                        ? 'text-primary-300 opacity-60'
                        : ''
                    }`}
                    dangerouslySetInnerHTML={{ __html: summary }}
                  />
                ) : (
                  <Loading />
                )}
              </div>
              {(isAdmin || canEdit) && (
                <Button type="edit" className="absolute top-2 right-2">
                  <QuickEdit onClick={() => setOpen(true)} />
                </Button>
              )}
            </>
          ) : (
            <Loading />
          )}
        </QueryErrorBoundary>
      </BorderedSection>
      <AntModal
        title={`Business Continuity Plan ${
          type === 'objective' ? 'Objective' : 'Scope'
        } `}
        openModal={open}
        onCancel={onCancel}
        width={1000}
      >
        <MissionForm
          type={type}
          data={data?.findStatementByPlan!}
          onCancel={onCancel}
        />
      </AntModal>
    </>
  );
}
